<template>
  <custom-popup
    v-model="dialog"
    :cons="{ title: 'خرید بسته دستیار هوش مصنوعی ' }"
    hide-confirm
    hide-overlay
    max-width="500"
    transition="dialog-bottom-transition"
    @close="discountField = { show: false, model: '' }"
  >
    <div key="prices" class="pa-4">
      <custom-tabs
        v-model="tabs"
        :tab-items="prices"
        :window-items="prices"
        fixed-tabs
      >
        <template v-slot:tab="{ tab }">
          {{ tab.title }}
        </template>

        <template v-slot:item="{ item }">
          <div class="pt-2 red--text">
            {{
              item.type === "free"
                ? "هم اکنون دسترسی رایگان را استفاده کنید"
                : "به مبلغ بسته خریداری شده ۱۰ درصد مالیات افزوده می‌شود!"
            }}
          </div>

          <v-list-item class="overflow-hidden border pa-2 rounded mt-2">
            <v-list-item-icon class="position-relative align-self-center">
              <div
                class="border border-2 rounded-circle position-absolute p-6"
                style="top: 50%; transform: translateY(-50%); right: -4em"
              >
                <v-icon size="70">mdi-plus-box</v-icon>
              </div>
            </v-list-item-icon>

            <v-list-item-content class="ms-4">
              <v-list-item-title>
                <h3 v-if="!!item.number">
                  <v-icon color="amber">mdi-clock</v-icon>
                  <small>بسته</small>
                  {{ item.type === "free" ? "رایگان" : item.number | currency }}
                  <small>بسته</small>
                </h3>

                <h3 class="d-flex align-center">
                  <v-icon color="amber darken-3">mdi-wallet</v-icon>
                  <div class="d-inline-block mr-1">
                    <span
                      :class="
                        !!item.discount && !!Number(item.discount)
                          ? 'text-decoration-line-through grey--text d-inline-block mb-1'
                          : ''
                      "
                    >
                      {{ item.type === "free" ? "0" : item.price | currency }}
                      <v-chip
                        v-if="!!item.discount && !!Number(item.discount)"
                        class="mr-2"
                        color="red"
                        dark
                        small
                      >
                        {{ item.type === "free" ? "" : item.discount }} %
                      </v-chip>
                    </span>
                    <template v-if="!!item.discount && !!Number(item.discount)">
                      <br />
                      {{
                        item.type === "free"
                          ? ""
                          : item | getDiscount | currency
                      }}
                    </template>
                    <small>{{ "ریال" }}</small>
                  </div>
                </h3>
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action class="d-flex flex-column">
              <v-btn
                :disabled="discountField.show"
                :loading="loading"
                color="green lighten-2"
                @click="upgradeQr(item.id)"
                >{{
                  item.type === "free" ? "دریافت دسترسی رایگان" : "خرید می‌کنم!"
                }}
              </v-btn>
              <v-btn
                v-if="item.type !== 'free'"
                :loading="loading"
                class="mt-2 mx-auto"
                color="primary"
                outlined
                small
                @click="
                  [
                    (discountField.show = !discountField.show),
                    (priceId = item.id),
                  ]
                "
              >
                {{ "کد تخفیف" }}
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </template>
      </custom-tabs>
    </div>

    <v-expand-transition>
      <div v-if="discountField.show" key="discount">
        <v-card-title>کد تخفیف</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="discountField.model"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            label="کد تخفیف"
            outlined
            prepend-inner-icon="mdi-percent-box"
          >
            <template v-slot:append-outer>
              <v-btn
                :loading="loading"
                class="mt-n1"
                color="green lighten-2"
                dark
                depressed
                @click="upgradeQr(priceId)"
              >
                ثبت
              </v-btn>
            </template>
          </v-text-field>
        </v-card-text>
      </div>
    </v-expand-transition>
  </custom-popup>
</template>

<script>
import axios from "axios";

export default {
  name: "upgradeAi",

  props: {
    value: Boolean,
    currentPackage: Object,
    assistantId: Number,
  },

  data: () => ({
    tabs: null,
    discountField: {
      show: false,
      model: "",
    },
    prices: [],
    loading: false,
    priceId: null,
  }),

  mounted() {
    this.getPackages();
    this.getPackage();
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    computedCurrent: {
      get() {
        return this.currentPackage;
      },
      set(val) {
        this.$emit("update:currentPackage", val);
      },
    },
  },

  filters: {
    getDiscount(price) {
      let p = Math.floor((Number(price.discount) * price.price) / 100);
      return price.price - p;
    },
  },

  methods: {
    header() {
      let token = localStorage.getItem("id_token");
      return {
        Authorization: token ? `Bearer ${token}` : null,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*",
        "Content-Type": "application/json",
      };
    },
    getPackage() {
      axios
        .get(this.$aiApi + "/packages/assistant", {
          headers: this.header(),
        })
        .then((data) => {
          this.computedCurrent = data.data;
        })
        .catch((response) => {
          console.error(response);
        })
        .finally(() => {});
    },
    getPackages() {
      this.loading = true;
      axios
        .get(this.$aiApi + "/packages/assistant", {
          headers: this.header(),
        })
        .then(({ data }) => {
          this.prices = data.data;
        })
        .finally(() => (this.loading = false));
    },
    upgradeQr(packageId) {
      this.loading = true;
      axios
        .get(
          `${this.$aiApi}/packages/assistant/buy/${packageId}?assist_id=${this.assistantId}`,
          {
            headers: this.header(),
          }
        )
        .then((response) => {
          this.dialog = false;
          this.$modal.success("موفقیت", "کیوآر شما با موفقیت ارتقا پیدا کرد.");
          this.getPackage();
        })
        .catch((reason) => {
          console.log(reason);
          if (reason.response.status === 402) {
            this.$modal.error(
              "خطا",
              "لطفا موجودی حساب خود را بررسی بفرمایید و مجدد تلاش کنید."
            );
          } else {
            this.$modal.error("خطا", "خطا در تمدید !");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>
